module.exports = __webpack_public_path__ + "img/screen03.5b57112d.jpg";